export default __webpack_public_path__ + "static/media/avatar2.7a4b3dd8.png";